import { render, staticRenderFns } from "./maskBox.vue?vue&type=template&id=04bbf2dd&scoped=true&"
import script from "./maskBox.vue?vue&type=script&lang=js&"
export * from "./maskBox.vue?vue&type=script&lang=js&"
import style0 from "./maskBox.vue?vue&type=style&index=0&id=04bbf2dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bbf2dd",
  null
  
)

export default component.exports